import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import type {StockPanelMessageProps} from './stock-panel-message.types';
import styles from './stock-panel-message.module.scss';

export function StockPanelMessage({icon, className, children}: StockPanelMessageProps): ReactElement {
  return (
    <div className={`_full-width flex-v-row flex-items-center gap-4 spacing-p-t-12 ${className ?? ''}`}>
      <div className={`${styles.iconContainer} radius-round flex-center spacing-p-3`}>
        <Icon className="content-body" icon={icon} size={IconSize.SIZE_ICON_24} type={IconType.NONE} shape={IconShape.NONE} />
      </div>
      {children}
    </div>
  );
}
